var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "400.945 277.64 40 40",
    enableBackground: "new 400.945 277.64 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M403.674,312.643h6.362v-15.454l-9.092-6.816v19.546C400.945,311.422,402.165,312.643,403.674,312.643"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M431.853,312.643h6.367c1.504,0,2.725-1.221,2.725-2.725v-19.546l-9.092,6.816"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M431.853,285.373v11.816l9.092-6.816v-3.638c0-3.374-3.848-5.293-6.543-3.271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M410.036,297.189v-11.816l10.908,8.184l10.908-8.184v11.816l-10.908,8.179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5221F",
    d: "M400.945,286.735v3.638l9.092,6.816v-11.816l-2.544-1.909C404.792,281.442,400.945,283.361,400.945,286.735 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGmail);
export default __webpack_public_path__ + "static/media/logo-gmail.bd83aecac78c8f331feffd15081d075e.svg";
export { ForwardRef as ReactComponent };